import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core';
import { AdminAccessinvestigationReport, AdminAccessinvestigationReportReadModel } from '../report-types/admin-access-investigation-report';
import { serializeDateTimeOffset } from '../../../core/serializers';

@Injectable()
export class AdminAccessInvestigationsStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public getReports(userPk: number, dateFrom: string, dateTo: string): Observable<AdminAccessinvestigationReport[]> {
        const dateFromWithOffset = serializeDateTimeOffset(moment(dateFrom));
        const dateToWithOffset = serializeDateTimeOffset(moment(dateTo));

        const params = new HttpParams()
            .set('userPk', userPk.toString())
            .set('dateFrom', dateFromWithOffset)
            .set('dateTo', dateToWithOffset);

        return this.http.get(`${this.settings.apiUrl}/admin/reports/access-investigation`, { params: params }).pipe(
            map((reports) => deserialize(reports, AdminAccessinvestigationReportReadModel).reports)
        );
    }
}
